export default __webpack_public_path__ + "static/me-a4d16772d6fb07e552db8d1f6def9f28.jpg";